/* eslint-disable camelcase */

import { getPublisherScoreValue, getPublisherTypeNameDL } from '@panel/commons/helpers';

const commonDataLayer = {
  event: 'trackEvent',
  eventCategory: 'Panel'
};

const claimDatalayer = {
  event: 'claim_response',
  content_group: 'Panel',
  content_type: 'Interesados-Detalle de Consulta'
};

const AgrupationDataLayer = {
  event: 'track_content_group',
  content_group: ''
};

const modalDataLayer = {
  event: 'click_modal'
};

const ModalTourDataLayer = {
  event: 'click_modal'
};

// Send GTM event
export function sendLeadsEvent(eventLabel) {
  if (window.dataLayer) {
    window.dataLayer.push({
      ...commonDataLayer,
      ...{ eventAction: 'Interesados', eventLabel }
    });
  }
}

export function trackContactos(eventLabel) {
  if (window.dataLayer) {
    window.dataLayer.push({
      ...commonDataLayer,
      ...{
        eventAction: 'Interesados-Listado de Consultas',
        eventLabel
      }
    });
  }
}

export function trackContacto(eventLabel) {
  if (window.dataLayer) {
    window.dataLayer.push({
      ...commonDataLayer,
      ...{
        eventAction: 'Interesados-Detalle de Consulta',
        eventLabel
      }
    });
  }
}

export function tracktabs(eventLabel) {
  if (window.dataLayer) {
    window.dataLayer.push({
      ...commonDataLayer,
      ...{
        eventAction: 'Interesados-Listado de Consultas',
        eventLabel
      }
    });
  }
}

export function trackChangueStatusList(eventLabel) {
  if (window.dataLayer) {
    window.dataLayer.push({
      ...commonDataLayer,
      ...{
        eventAction: 'Interesados-Listado de Consultas',
        eventLabel
      }
    });
  }
}

export function trackChangueStatusChat(eventLabel) {
  if (window.dataLayer) {
    window.dataLayer.push({
      ...commonDataLayer,
      ...{
        eventAction: 'Interesados-Detalle de Consulta',
        eventLabel
      }
    });
  }
}

export function trackContentGroup(contentGroup, contentType, userLoggedId, publisherTypeId, mainReputationLevel) {
  if (window.dataLayer) {
    window.dataLayer.push({
      ...AgrupationDataLayer,
      ...{
        event: 'track_content_group',
        content_group: contentGroup && contentGroup,
        content_type: contentType && contentType,
        user_id: userLoggedId,
        user_type: getPublisherTypeNameDL(publisherTypeId),
        user_reputation: getPublisherScoreValue(mainReputationLevel)
      }
    });
  }
}

export function trackSpamContactos(eventLabel, eventValue) {
  if (window.dataLayer && eventValue) {
    window.dataLayer.push({
      ...commonDataLayer,
      ...{
        eventAction: 'Interesados-Listado de Consultas',
        eventLabel,
        eventValue
      }
    });
  }
}

export function welcomeModalTrack(eventLabel) {
  if (window.dataLayer) {
    window.dataLayer.push({
      ...modalDataLayer,
      ...{
        modal_name: 'Modal de bienvenida tour virtual',
        eventLabel
      }
    });
  }
}

export function tourModalTrack(name, action) {
  if (window.dataLayer) {
    window.dataLayer.push({
      ...ModalTourDataLayer,
      ...{
        modal_name: name,
        selection_value: action
      }
    });
  }
}

export function trackTour(eventLabel) {
  if (window.dataLayer) {
    window.dataLayer.push({
      ...modalDataLayer,
      ...{
        modal_name: 'Modal de bienvenida tour virtual',
        eventLabel
      }
    });
  }
}

export function trackGarantias(eventLabel) {
  if (window.dataLayer) {
    window.dataLayer.push({
      ...commonDataLayer,
      ...{
        eventAction: 'Interesados-Estado de la Garantia',
        eventLabel
      }
    });
  }
}

export function trackCtaGarantias(eventLabel) {
  if (window.dataLayer) {
    window.dataLayer.push({
      ...commonDataLayer,
      ...{
        eventAction: 'Interesados-Estado de la Garantia',
        eventLabel
      }
    });
  }
}

export function trackClaimResponse(item_id) {
  if (window.dataLayer) {
    window.dataLayer.push({
      ...claimDatalayer,
      ...{
        item_id
      }
    });
  }
}

export function trackMessages(eventLabel) {
  if (window.dataLayer) {
    window.dataLayer.push({
      event: 'trackEvent',
      eventCategory: 'Mi Actividad',
      eventAction: 'Mensajes',
      eventLabel
    });
  }
}

const SeekerDataLayer = {
  event: 'trackEvent',
  content_type: 'Mi actividad-Mensajes',
  content_group: 'Panel'
};

export function trackTermsAndConditions(eventValue) {
  if (window.dataLayer && eventValue) {
    window.dataLayer.push({
      ...commonDataLayer,
      ...{
        event: 'click_modal',
        modal_name: 'Anunciantes - Terminos y condiciones',
        item_id: eventValue
      }
    });
  }
}

export function trackTermsAndConditionsImpression() {
  if (window.dataLayer) {
    window.dataLayer.push({
      ...commonDataLayer,
      ...{
        event: 'impression_modal',
        modal_name: 'Anunciantes - Terminos y condiciones'
      }
    });
  }
}

export function trackTermsAndConditionsImpressionSeeker() {
  if (window.dataLayer) {
    window.dataLayer.push({
      ...{
        event: 'impression_modal',
        modal_name: 'Terminos y condiciones',
        content_type: 'Mi actividad-Mensajes'
      }
    });
  }
}

export function trackTermsAndConditionsSeeker(eventValue) {
  if (window.dataLayer && eventValue) {
    window.dataLayer.push({
      ...{
        event: 'click_modal',
        modal_name: 'Terminos y condiciones',
        content_type: 'Mi actividad-Mensajes',
        item_id: eventValue
      }
    });
  }
}

export function UploadTrackSeeker(eventLabel) {
  if (window.dataLayer) {
    window.dataLayer.push({
      ...{
        event: eventLabel
      }
    });
  }
}

export function getEventLabel(status) {
  let eventLabel;
  // eslint-disable-next-line default-case
  switch (status) {
    case 'DETAIL':
      eventLabel = 'Ver detalle';
      break;
    case 'READ':
      eventLabel = 'Marcar como leido';
      break;
    case 'UNREAD':
      eventLabel = 'Marcar como no Leido';
      break;
    case 'FAVORITE':
      eventLabel = 'Marcar como destacado';
      break;
    case 'NONFAVORITE':
      eventLabel = 'No destacar';
      break;
    case 'DISCARDED':
      eventLabel = 'Eliminar';
      break;
    case 'NONDISCARDED':
      eventLabel = 'Restaurar consultas';
      break;
    case 'SPAM':
      eventLabel = 'Marcar como spam';
      break;
    case 'BACK':
      eventLabel = 'Volver atras';
      break;
  }
  return eventLabel;
}

export function getEventLabelFavorite(status) {
  let eventLabel;
  // eslint-disable-next-line default-case
  switch (status) {
    case 'FAVORITE':
      eventLabel = 'Destacar consulta';
      break;
    case 'NONFAVORITE':
      eventLabel = 'No destacar consulta';
      break;
  }
  return eventLabel;
}

export function UploadTrack(eventLabel) {
  if (window.dataLayer) {
    window.dataLayer.push({
      ...modalDataLayer,
      ...{
        event: eventLabel
      }
    });
  }
}

export function trackFeedback(eventLabel) {
  if (window.dataLayer) {
    window.dataLayer.push({
      ...commonDataLayer,
      ...{
        eventAction: 'Interesados-Detalle de Consulta',
        eventLabel
      }
    });
  }
}
